<template>
    <div>
        <h1>
            404 NOT FOUND
        </h1>
    <button v-on:click="goBackToMain">GO BACK</button>
    </div>    
</template>
<script>
export default {
  name: "notfound",
  methods: {
    goBackToMain() {
      this.$router.push('/');
      this.$router.go();
    }
  }
};
</script>
<style>

</style>